import LANG from '@ahoy/model/dist/utils/locale/lang';
import { ts } from '@ahoy/model/dist/utils/locale';

type Key = keyof typeof LANG;
export function t(v: Key | string, ...rest: any[]) {
  // this function looks for the agent text key in the LANG object and returns its value if exists
  const checkAgentText = (v: string) => {
    const userType = (window as any)['userType'];
    if (userType == 'agent' || userType == 'externalAgent') {
      const agentTextKey = v + '_AGENT';      
      const isAgentTextKeyFound = String(LANG[agentTextKey as Key] || '');
      if (isAgentTextKeyFound) return ts(agentTextKey, ...rest);
    }
    return '';
  };
  // this function checks if the user is an agent and if so, it returns the agent text if it exists
  let agentText: string = checkAgentText(v);
  const userText = ts(v, ...rest);
  return agentText || userText;  
};